import { Fragment } from 'react';

export function UserDutiesRegardingCopyrightLaw() {
  return (
    <Fragment>
      Users are required to abide by copyright law in the jurisdiction in which the User accesses such copyrighted materials. Different jurisdictions may have significantly different copyright law, and it is incumbent upon Users to understand the laws in their jurisdiction. Copyright law may protect works that manifest as text, images, audio, video, and other media, may be applicable to portions of such works, and may apply to the copying, reproduction, transmission, and dissemination of these works. Exemptions may exist for cultural or educational use in certain jurisdictions.
      <br /><br />
      Users should be aware that copyright law may extend beyond simple display of works under copyright and may be applicable to text and data mining activities on data provided through our services on the site, on the mobile applications, and through the API. Any exceptions and exemptions will be governed by applicable law.
      <br /><br />
      Any copyright provision in copyright legislation that contradicts this agreement shall prevail and supersede these terms.
    </Fragment>
  );
}


export default UserDutiesRegardingCopyrightLaw;
